module.exports = __webpack_public_path__ + "static/lifting-06-927f2b393b4a843ae98678b1cc04b6b5.jpg";